import React from 'react';

/** A retrieved chunk beside a governed atom — the same rule, two asset classes. */
export function ChunkVsAtom() {
  return <div style={{
    width: '100%',
    maxWidth: 440,
    margin: '0 auto'
  }} data-id="element-72" data-mp="32a3ksrgk0yb5">
      <div className="artifact" data-id="element-73" data-mp="3h8p2s8e11q1o">
        <div className="ah" data-id="element-74" data-mp="3h7njjgmuxx8v">
          <span className="k" data-id="element-75" data-mp="3h5t6splqpbfv">CHUNK &middot; RANKED</span>
          <span className="when" data-id="element-76" data-mp="3caduw37alpm3">today</span>
        </div>
        <div className="rule" data-id="element-77" data-mp="2oj8gztkwx7ef" />
        <p className="quote" data-id="element-78" data-mp="2okjjzr6jab4h">
          &hellip;representatives should be mindful, when discussing performance, to avoid language that could be
          construed as implying guaranteed ret&hellip;
        </p>
        <div className="ar" data-id="element-79" data-mp="2ya31asellwx8">
          <span data-id="element-80" data-mp="2ybe4aq07z0na">trigger</span>
          <span data-id="element-81" data-mp="2ti1jys2kpg0c">none</span>
        </div>
        <div className="ar" data-id="element-82" data-mp="2th08imhnari3">
          <span data-id="element-83" data-mp="2tgqhcvkv6eat">version</span>
          <span data-id="element-84" data-mp="25sgyo2iy66nw">none</span>
        </div>
      </div>

      <div style={{
      height: 28
    }} data-id="element-85" data-mp="25r5ysdsmhj22" />

      <div className="artifact gov" data-id="element-86" data-mp="20u5ofqoqpu55">
        <div className="ah" data-id="element-87" data-mp="20t4czl3tb5mw">
          <span className="k" data-id="element-88" data-mp="20rt97lad9xvs">ATOM &middot; GOVERNED</span>
          <span className="when" data-id="element-89" data-mp="la9nn55weqc4">pre-flight</span>
        </div>
        <div className="rule" data-id="element-90" data-mp="pcwfh62kkb9b" />
        <p className="quote" data-id="element-91" data-mp="pbutw7nxg6dc">&ldquo;Do not state or imply guaranteed returns.&rdquo;</p>
        <div className="ar" data-id="element-92" data-mp="u3cvmxxryazd">
          <span data-id="element-93" data-mp="u466ob3rnmnb">trigger</span>
          <span data-id="element-94" data-mp="u5z36xko0qhl">performance language</span>
        </div>
        <div className="ar" data-id="element-95" data-mp="z1o87gfgezla">
          <span data-id="element-96" data-mp="z4tvcq4ivred">version</span>
          <span data-id="element-97" data-mp="2cq9jn4l2hiu">v7 &middot; supersedes v6</span>
        </div>
        <div className="ar" data-id="element-98" data-mp="2e9rdi5w10mq">
          <span data-id="element-99" data-mp="6e24m8687uyf">receipt</span>
          <span className="ok" data-id="element-100" data-mp="6da88v4t1t73">ready</span>
        </div>
      </div>
    </div>;
}